<style lang="scss" scoped="">
.container::-webkit-scrollbar {
  display: none;
}

.mytable {}
</style>

<template>
  <div class="container" ref="container" style="overflow: auto;position: relative">
    <p style="font-size: 18px;color: #F4F4F4;">{{ $t('chanliangzhibiao') }}</p>
    <p style="font-size: 14px;color: #C0C4CC;margin-top: 18px;">{{ $t('banzhichanliang') }}</p>
    <p style="font-size: 24px;color: #FFFFFF;">
      {{ tabsData.eqPoints['ShiftProduct'] ? parseInt(tabsData.eqPoints['ShiftProduct']) : '-' }}
    </p>
    <p style="font-size: 14px;color: #C0C4CC;margin-top: 12px;">{{ $t('meixiaoshichanliang') }}</p>
    <div id="workshopEquipmentTabProduceChart" :style="{ height: chartHeight1 + 'px' }" style="margin-top: 12px;"></div>
    <p style="font-size: 18px;color: #F4F4F4;margin-top: 36px;">{{ $t('dangrishebeizhuangtai') }}</p>
    <div style="display: flex;margin-top: 18px;">
      <div style="margin-right:80px;">
        <div style="display: flex;align-items: center;">
          <div style="width:5px;height: 14px ;background-color: #7DFFBE;margin-right: 8px;"></div>
          <p style="font-size: 14px;color: #C0C4CC;">{{ $t('yunxingshijian') }}</p>
        </div>
        <p v-if="this.tabsData.eqPoints['ShiftRunTime']" style="font-size: 24px;color: #FFFFFF;">{{ (this.tabsData.eqPoints['ShiftRunTime'] / 1).toFixed(1) }}h</p>
      </div>
      <div style="margin-right:80px;">
        <div style="display: flex;align-items: center;">
          <div style="width:5px;height: 14px ;background-color: #FFD580;margin-right: 8px;"></div>
          <p style="font-size: 14px;color: #C0C4CC;">{{ $t('kongxianshijian') }}</p>
        </div>
        <p v-if="this.tabsData.eqPoints['ShiftIdleTime']" style="font-size: 24px;color: #FFFFFF;">{{ (this.tabsData.eqPoints['ShiftIdleTime'] / 1).toFixed(1) }}h</p>
      </div>
      <div style="margin-right:80px;">
        <div style="display: flex;align-items: center;">
          <div style="width:5px;height: 14px ;background-color: #FF809F;margin-right: 8px;"></div>
          <p style="font-size: 14px;color: #C0C4CC;">{{ $t('guzhangshijian') }}</p>
        </div>
        <p v-if="this.tabsData.eqPoints['ShiftFaultTime']" style="font-size: 24px;color: #FFFFFF;">{{ (this.tabsData.eqPoints['ShiftFaultTime'] / 1).toFixed(1) }}h</p>
      </div>
      <div style="margin-right:80px;">
        <div style="display: flex;align-items: center;">
          <div style="width:5px;height: 14px ;background-color: #7582A3;margin-right: 8px;"></div>
          <p style="font-size: 14px;color: #C0C4CC;">{{ $t('lixianshijian') }}</p>
        </div>
        <p v-if="this.tabsData.eqPoints['ShiftOfflineTime']" style="font-size: 24px;color: #FFFFFF;">{{ (this.tabsData.eqPoints['ShiftOfflineTime'] / 1).toFixed(1) }}h</p>
      </div>
    </div>

    <div id="workshopEquipmentTabStatusChart" :style="{ height: chartHeight2 + 'px' }" style="margin-top: 8px;"></div>

    <div v-if="tj" style="color: white;">
      <p style="font-size: 18px;color: #F4F4F4;margin-bottom: 18px;">{{ $t('qitazhibiao') }}</p>
      <div class="mytable" v-html="tj"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
const execMathExpress = require('exec-mathexpress');
export default {
  name: 'web_monitor_equipment_statistics_tabs_produce',
  components: {},
  props: {
    equipment: {
      type: Object,
      default: function () {
        return {};
      }
    },
    tabsData: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  watch: {
    'equipment.id'(newValue, oldValue) {
      this.chart1.dispose();
      this.chart1 = null;
      this.chart2.dispose();
      this.chart2 = null;
      this.getEquipmentShiftHourProduct();
      this.getEquipmentShitState();
    }
  },
  data() {
    return {
      timmer: null,
      chart1: null,
      options1: null,
      chartHeight1: 200,
      chart1TimeData: [],
      chart1ValueData: [],
      chart2: null,
      options2: null,
      chartHeight2: 120,
      chart2ValueData: [],
      statusColors: {
        '0': '#7DFFBE',
        '3': '#FF809F',
        '1': '#FFD580',
        '-1': '#7582A3',
        '-2': '#7582A3'
      }
    };
  },
  computed: {
    tj() {
      if (!this.tabsData.tab.tj) {
        return null;
      }
      let str = this.tabsData.tab.tj;
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map(code => {
          let c = code.replace('[', '');
          c = c.replace(']', '');
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map(code => {
          let c = code.replace('{', '');
          c = c.replace('}', '');

          if (!this.store.state.eqPoints[this.equipment.id][c]) {
            console.log('qitamobanqueshaodian' + ':' + c);
            return;
          }

          if (this.store.state.eqPoints[this.equipment.id][c].dictTypeCode != null) {
            str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.store.state.eqPoints[this.equipment.id][c].dictTypeCode][parseInt(this.tabsData.eqPoints[c])]));
          } else {
            str = str.replace(code, isNaN(Number(this.tabsData.eqPoints[c]).toFixed(2)) ? '' : Number(this.tabsData.eqPoints[c]).toFixed(2));
          }
        });
      return str;
    }
  },
  created() {
    this.timmer = setInterval(() => {
      this.getEquipmentShiftHourProduct();
      this.getEquipmentShitState();
    }, 120000);
    this.getEquipmentShiftHourProduct();
    this.getEquipmentShitState();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (this.chart1) {
          this.chart1.resize();
        }
        if (this.chart2) {
          this.chart2.resize();
        }
      }, 500);
    },
    async getEquipmentShiftHourProduct() {
      try {
        let response = await this.http.get('/web/equipment/getEquipmentShiftHourProduct', {
          params: {
            equipmentId: this.equipment.id
          }
        });
        this.chart1TimeData = response.data.map(item => {
          return item.t;
        });
        this.chart1ValueData = response.data.map(item => {
          return item.v; // parseInt(Math.random() * 1000) //
        });
        if (!this.chart1) {
          setTimeout(() => {
            this.initChart1();
          }, 100);
        } else {
          this.option1.series[0].data = this.chart1ValueData;
          this.chart1.setOption(this.option1);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getEquipmentShitState() {
      let response = await this.http.get('/web/equipment/getEquipmentShitState', {
        params: {
          equipmentId: this.equipment.id
        }
      });

      //总时长
      this.chart2ValueData = response.data.map(item => {
        item.last = (this.dayjs(item.et).unix() - this.dayjs(item.st).unix()) / 3600;

        return {
          s: item.s,
          st: item.st,
          et: item.et,
          name: '',
          type: 'bar',
          stack: 'total',
          label: {
            show: false
          },
          emphasis: {
            focus: 'series'
          },
          itemStyle: {
            normal: {
              color: this.statusColors[item.s],
              barBorderRadius: 0
            }
          },
          data: [item.last]
        };
      });

      if (!this.chart2) {
        setTimeout(() => {
          this.initChart2();
        }, 100);
      } else {
        //班制变更，那么就是新的比旧的少，需要重新创建
        if (this.chart2ValueData.length < this.options2.series) {
          this.chart2.dispose();
          this.chart2 = null;
          this.initChart2();
        }
        this.option2.series = this.chart2ValueData;
        this.chart2.setOption(this.option2);
      }
    },

    initChart1() {
      this.option1 = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '18',
          containLabel: true
        },

        xAxis: {
          show: true,
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },

          axisTick: {
            show: false
          },
          type: 'category',
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: '#C0C4CC'
            },
            interval: 'auto'
          },
          data: this.chart1TimeData
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            min: 0,

            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: '#C0C4CC'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('chanliang'),
            type: 'bar',
            barWidth: '8px',
            label: {
              // 	formatter: "{c}" + "人",
              show: true,
              position: 'top',
              textStyle: {
                fontSize: '12',
                color: '#419FFF'
              }
            },
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#6FE5FF'
                  },
                  {
                    offset: 1,
                    color: '#1C70C6'
                  }
                ]),
                barBorderRadius: 4
              }
            },

            data: this.chart1ValueData
          }
        ]
      };
      var chartDom = document.getElementById('workshopEquipmentTabProduceChart');
      this.chart1 = this.echarts.init(chartDom);
      this.option1 && this.chart1.setOption(this.option1);
    },
    initChart2() {
      this.option2 = {
        tooltip: {
          show: false,
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          show: false
        },
        grid: {
          top: '10',
          left: '0',
          right: '10',
          bottom: '30',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          minInterval: 1,
          maxInterval: 1,
          axisLabel: {
            formatter: (value, index) => {
              if (this.chart2ValueData) {
                return (this.dayjs(this.chart2ValueData[0].st).hour() + index) % 24;
              }

              return '-';
            }
          }
        },
        yAxis: {
          show: false,
          type: 'category'
        },
        series: this.chart2ValueData
      };
      var chartDom = document.getElementById('workshopEquipmentTabStatusChart');
      this.chart2 = this.echarts.init(chartDom);
      this.option2 && this.chart2.setOption(this.option2);
    }
  }
};
</script>
